import { useWorkflow } from 'hooks/useWorkflow'

type AuditWorkflowProps = {
  workflowId: number
}

const AuditWorkflow = ({ workflowId }: AuditWorkflowProps) => {
  const { data: workflow } = useWorkflow(workflowId)

  return workflow ? `${workflow.name}` : '–'
}

export default AuditWorkflow
